import { render, staticRenderFns } from "./UsersHistoryList.vue?vue&type=template&id=d84b057c&"
import script from "./UsersHistoryList.vue?vue&type=script&lang=js&"
export * from "./UsersHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports